import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Heart } from "lucide-react";

const Datenschutz = () => {
  return (
    <div className="min-h-screen bg-gradient-subtle">
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 border-b border-white/10 backdrop-blur-sm bg-background/80">
        <div className="container mx-auto px-4 py-4">
          <div className="flex justify-between items-center">
            <Link to="/">
              <h1 className="text-2xl font-bold gradient-text cursor-pointer hover:opacity-80 transition-opacity">
                MediQR
              </h1>
            </Link>
            <Link to="/">
              <Button variant="outline">Zurück zur Startseite</Button>
            </Link>
          </div>
        </div>
      </nav>

      {/* Content */}
      <div className="pt-32 pb-20 px-4">
        <div className="container mx-auto max-w-4xl">
          <div className="glass p-8 md:p-12 rounded-2xl">
            <h1 className="text-4xl font-bold mb-8 gradient-text">Datenschutzerklärung</h1>
            
            <div className="space-y-8 text-foreground">
              <section>
                <h2 className="text-2xl font-semibold mb-4">1. Datenschutz auf einen Blick</h2>
                
                <h3 className="text-xl font-semibold mb-3 mt-6">Allgemeine Hinweise</h3>
                <div className="text-muted-foreground space-y-3">
                  <p>
                    Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten 
                    passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie 
                    persönlich identifiziert werden können.
                  </p>
                </div>

                <h3 className="text-xl font-semibold mb-3 mt-6">Datenerfassung auf dieser Website</h3>
                <div className="text-muted-foreground space-y-3">
                  <p className="font-medium text-foreground">Wer ist verantwortlich für die Datenerfassung auf dieser Website?</p>
                  <p>
                    Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten 
                    können Sie dem Impressum dieser Website entnehmen.
                  </p>
                  
                  <p className="font-medium text-foreground mt-4">Wie erfassen wir Ihre Daten?</p>
                  <p>
                    Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich z.B. um 
                    Daten handeln, die Sie in ein Kontaktformular eingeben oder bei der Registrierung angeben.
                  </p>
                  <p>
                    Andere Daten werden automatisch oder nach Ihrer Einwilligung beim Besuch der Website durch unsere 
                    IT-Systeme erfasst. Das sind vor allem technische Daten (z.B. Internetbrowser, Betriebssystem oder 
                    Uhrzeit des Seitenaufrufs).
                  </p>

                  <p className="font-medium text-foreground mt-4">Wofür nutzen wir Ihre Daten?</p>
                  <p>
                    Die Daten werden erhoben, um eine fehlerfreie Bereitstellung der Website zu gewährleisten und um die 
                    Funktionen der Website zu ermöglichen. Bei MediQR werden Ihre medizinischen Daten ausschließlich 
                    verwendet, um im Notfall Rettungskräften lebensrettende Informationen zur Verfügung zu stellen.
                  </p>

                  <p className="font-medium text-foreground mt-4">Welche Rechte haben Sie bezüglich Ihrer Daten?</p>
                  <p>
                    Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft, Empfänger und Zweck Ihrer 
                    gespeicherten personenbezogenen Daten zu erhalten. Sie haben außerdem ein Recht, die Berichtigung oder 
                    Löschung dieser Daten zu verlangen. Wenn Sie eine Einwilligung zur Datenverarbeitung erteilt haben, 
                    können Sie diese Einwilligung jederzeit für die Zukunft widerrufen.
                  </p>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4">2. Hosting und CDN</h2>
                
                <h3 className="text-xl font-semibold mb-3 mt-6">Externes Hosting (Hetzner)</h3>
                <div className="text-muted-foreground space-y-3">
                  <p>
                    Wir hosten die Inhalte unserer Website bei folgendem Anbieter: Hetzner. Die personenbezogenen Daten, 
                    die auf dieser Website erfasst werden, werden auf den Servern des Hosters gespeichert. Hierbei kann es 
                    sich v.a. um IP-Adressen, Kontaktanfragen, Meta- und Kommunikationsdaten, Vertragsdaten, Kontaktdaten, 
                    Namen, Websitezugriffe und sonstige Daten, die über eine Website generiert werden, handeln.
                  </p>
                  <p>
                    Die Rechtsgrundlage für die Verwendung von Hetzner ist Art. 6 Abs. 1 lit. f DSGVO.
                  </p>
                </div>

                <h3 className="text-xl font-semibold mb-3 mt-6">Cloudflare</h3>
                <div className="text-muted-foreground space-y-3">
                  <p>
                    Wir nutzen den Service „Cloudflare". Anbieter ist die Cloudflare Inc., 101 Townsend St., San Francisco, 
                    CA 94107, USA (im Folgenden „Cloudflare").
                  </p>
                  <p>
                    Cloudflare bietet ein weltweit verteiltes Content Delivery Network mit DNS an. Dabei wird technisch der 
                    Informationstransfer zwischen Ihrem Browser und unserer Website über das Netzwerk von Cloudflare geleitet. 
                    Das versetzt Cloudflare in die Lage, den Datenverkehr zwischen Ihrem Browser und unserer Website zu 
                    analysieren und als Filter zwischen unseren Servern und potenziell bösartigem Datenverkehr aus dem Internet 
                    zu dienen. Hierbei kann Cloudflare auch Cookies oder sonstige Technologien zur Wiedererkennung von 
                    Internetnutzern einsetzen, die jedoch allein zum hier beschriebenen Zweck verwendet werden.
                  </p>
                  <p>
                    Der Einsatz von Cloudflare beruht auf unserem berechtigten Interesse an einer möglichst fehlerfreien und 
                    sicheren Bereitstellung unseres Webangebotes (Art. 6 Abs. 1 lit. f DSGVO).
                  </p>
                  <p>
                    Die Datenübertragung in die USA wird auf die Standardvertragsklauseln der EU-Kommission gestützt. Details 
                    finden Sie hier:{" "}
                    <a 
                      href="https://www.cloudflare.com/privacypolicy/" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="text-primary hover:underline"
                    >
                      https://www.cloudflare.com/privacypolicy/
                    </a>
                  </p>
                  <p>
                    Weitere Informationen zum Thema Sicherheit und Datenschutz bei Cloudflare finden Sie hier:{" "}
                    <a 
                      href="https://www.cloudflare.com/privacypolicy/" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="text-primary hover:underline"
                    >
                      https://www.cloudflare.com/privacypolicy/
                    </a>
                  </p>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4">3. Allgemeine Hinweise und Pflichtinformationen</h2>
                
                <h3 className="text-xl font-semibold mb-3 mt-6">Datenschutz</h3>
                <div className="text-muted-foreground space-y-3">
                  <p>
                    Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln Ihre 
                    personenbezogenen Daten vertraulich und entsprechend den gesetzlichen Datenschutzvorschriften sowie 
                    dieser Datenschutzerklärung.
                  </p>
                  <p>
                    Wenn Sie diese Website benutzen, werden verschiedene personenbezogene Daten erhoben. Personenbezogene 
                    Daten sind Daten, mit denen Sie persönlich identifiziert werden können. Die vorliegende 
                    Datenschutzerklärung erläutert, welche Daten wir erheben und wofür wir sie nutzen. Sie erläutert auch, 
                    wie und zu welchem Zweck das geschieht.
                  </p>
                </div>

                <h3 className="text-xl font-semibold mb-3 mt-6">Hinweis zur verantwortlichen Stelle</h3>
                <div className="text-muted-foreground space-y-3">
                  <p>Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:</p>
                  <div className="mt-2 space-y-1">
                    <p>Einzelunternehmer</p>
                    <p>Robin Dieker</p>
                    <p>Zum roten Berge 19</p>
                    <p>48165 Münster</p>
                    <p className="mt-2">
                      Telefon: +49 15 678 324 195<br />
                      E-Mail: R.Dieker@DiekerIT.com
                    </p>
                  </div>
                  <p className="mt-3">
                    Verantwortliche Stelle ist die natürliche oder juristische Person, die allein oder gemeinsam mit anderen 
                    über die Zwecke und Mittel der Verarbeitung von personenbezogenen Daten (z.B. Namen, E-Mail-Adressen o. Ä.) 
                    entscheidet.
                  </p>
                </div>

                <h3 className="text-xl font-semibold mb-3 mt-6">Speicherdauer</h3>
                <div className="text-muted-foreground space-y-3">
                  <p>
                    Soweit innerhalb dieser Datenschutzerklärung keine speziellere Speicherdauer genannt wurde, verbleiben 
                    Ihre personenbezogenen Daten bei uns, bis der Zweck für die Datenverarbeitung entfällt. Wenn Sie ein 
                    berechtigtes Löschersuchen geltend machen oder eine Einwilligung zur Datenverarbeitung widerrufen, 
                    werden Ihre Daten gelöscht, sofern wir keine anderen rechtlich zulässigen Gründe für die Speicherung 
                    Ihrer personenbezogenen Daten haben.
                  </p>
                </div>

                <h3 className="text-xl font-semibold mb-3 mt-6">Widerruf Ihrer Einwilligung zur Datenverarbeitung</h3>
                <div className="text-muted-foreground space-y-3">
                  <p>
                    Viele Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen Einwilligung möglich. Sie können eine 
                    bereits erteilte Einwilligung jederzeit widerrufen. Die Rechtmäßigkeit der bis zum Widerruf erfolgten 
                    Datenverarbeitung bleibt vom Widerruf unberührt.
                  </p>
                </div>

                <h3 className="text-xl font-semibold mb-3 mt-6">Recht auf Datenübertragbarkeit</h3>
                <div className="text-muted-foreground space-y-3">
                  <p>
                    Sie haben das Recht, Daten, die wir auf Grundlage Ihrer Einwilligung oder in Erfüllung eines Vertrags 
                    automatisiert verarbeiten, an sich oder an einen Dritten in einem gängigen, maschinenlesbaren Format 
                    aushändigen zu lassen.
                  </p>
                </div>

                <h3 className="text-xl font-semibold mb-3 mt-6">Auskunft, Löschung und Berichtigung</h3>
                <div className="text-muted-foreground space-y-3">
                  <p>
                    Sie haben im Rahmen der geltenden gesetzlichen Bestimmungen jederzeit das Recht auf unentgeltliche 
                    Auskunft über Ihre gespeicherten personenbezogenen Daten, deren Herkunft und Empfänger und den Zweck 
                    der Datenverarbeitung und ggf. ein Recht auf Berichtigung oder Löschung dieser Daten.
                  </p>
                </div>

                <h3 className="text-xl font-semibold mb-3 mt-6">Recht auf Einschränkung der Verarbeitung</h3>
                <div className="text-muted-foreground space-y-3">
                  <p>
                    Sie haben das Recht, die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen. 
                    Hierzu können Sie sich jederzeit an uns wenden. Das Recht auf Einschränkung der Verarbeitung besteht 
                    in folgenden Fällen: wenn Sie die Richtigkeit Ihrer bei uns gespeicherten personenbezogenen Daten 
                    bestreiten, wenn die Verarbeitung Ihrer personenbezogenen Daten unrechtmäßig geschah/geschieht, Sie 
                    jedoch deren Löschung ablehnen, oder wenn wir Ihre personenbezogenen Daten nicht mehr benötigen.
                  </p>
                </div>

                <h3 className="text-xl font-semibold mb-3 mt-6">Datenübermittlung in Drittländer (USA)</h3>
                <div className="text-muted-foreground space-y-3">
                  <p>
                    Wir nutzen unter anderem Tools von Unternehmen mit Sitz in den USA oder sonstigen datenschutzrechtlich 
                    nicht sicheren Drittstaaten. Wenn diese Tools aktiv sind, können Ihre personenbezogene Daten in diese 
                    Drittstaaten übertragen und dort verarbeitet werden. Wir weisen darauf hin, dass in diesen Ländern kein 
                    mit der EU vergleichbares Datenschutzniveau garantiert werden kann.
                  </p>
                  <p>
                    Wir weisen darauf hin, dass die USA als sicheres Drittland grundsätzlich ein mit der EU vergleichbares 
                    Datenschutzniveau aufweisen. Eine Datenübertragung in die USA ist danach zulässig, wenn der Empfänger eine 
                    Zertifizierung unter dem „EU-US Data Privacy Framework" (DPF) besitzt oder über geeignete zusätzliche 
                    Garantien verfügt. Informationen zu Übermittlungen an Drittstaaten einschließlich der Datenempfänger finden 
                    Sie in dieser Datenschutzerklärung.
                  </p>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4">4. Cookies und Analysetools</h2>
                
                <h3 className="text-xl font-semibold mb-3 mt-6">Cookies</h3>
                <div className="text-muted-foreground space-y-3">
                  <p>
                    Unsere Internetseiten verwenden so genannte „Cookies". Cookies sind kleine Datenpakete und richten auf 
                    Ihrem Endgerät keinen Schaden an. Sie werden entweder vorübergehend für die Dauer einer Sitzung (Session-Cookies) 
                    oder dauerhaft (permanente Cookies) auf Ihrem Endgerät gespeichert.
                  </p>
                  <p>
                    Session-Cookies werden nach Ende Ihres Besuchs automatisch gelöscht. Permanente Cookies bleiben auf Ihrem 
                    Endgerät gespeichert, bis Sie diese selbst löschen oder eine automatische Löschung durch Ihren Webbrowser erfolgt.
                  </p>
                  
                  <p className="font-medium text-foreground mt-4">Notwendige Cookies</p>
                  <p>
                    Wir setzen notwendige Cookies ein, um Ihnen die grundlegenden Funktionen unserer Website bereitzustellen. 
                    Diese Cookies sind technisch erforderlich und können nicht abgelehnt werden. Sie dienen unter anderem der 
                    Speicherung Ihrer Cookie-Präferenzen und der Authentifizierung.
                  </p>
                  <p>
                    Die Rechtsgrundlage für die Verwendung technisch notwendiger Cookies ist unser berechtigtes Interesse an 
                    einer funktionsfähigen Website (Art. 6 Abs. 1 lit. f DSGVO).
                  </p>

                  <p className="font-medium text-foreground mt-4">Analyse-Cookies (Google Analytics)</p>
                  <p>
                    Sofern Sie Ihre Einwilligung erteilt haben, setzen wir Analyse-Cookies ein, um die Nutzung unserer Website 
                    zu analysieren und zu verbessern. Diese Cookies werden nur mit Ihrer ausdrücklichen Zustimmung gesetzt.
                  </p>
                  <p>
                    Sie können Ihre Cookie-Einstellungen jederzeit über das Cookie-Banner ändern, das Sie über einen Link im 
                    Footer dieser Website erneut aufrufen können. Sie können Ihre Einwilligung jederzeit widerrufen, ohne dass 
                    die Rechtmäßigkeit der aufgrund der Einwilligung bis zum Widerruf erfolgten Verarbeitung berührt wird.
                  </p>
                </div>

                <h3 className="text-xl font-semibold mb-3 mt-6">Google Analytics</h3>
                <div className="text-muted-foreground space-y-3">
                  <p>
                    Diese Website nutzt Funktionen des Webanalysedienstes Google Analytics. Anbieter ist die Google Ireland Limited 
                    („Google"), Gordon House, Barrow Street, Dublin 4, Irland.
                  </p>
                  
                  <p className="font-medium text-foreground mt-4">Umfang der Verarbeitung</p>
                  <p>
                    Google Analytics verwendet Cookies, die eine Analyse der Benutzung der Website durch Sie ermöglichen. Die durch 
                    das Cookie erzeugten Informationen über Ihre Benutzung dieser Website werden in der Regel an einen Server von 
                    Google in den USA übertragen und dort gespeichert.
                  </p>
                  <p>
                    Die im Rahmen von Google Analytics von Ihrem Browser übermittelte IP-Adresse wird nicht mit anderen Daten von 
                    Google zusammengeführt. Wir haben auf dieser Website die IP-Anonymisierung aktiviert. Dadurch wird Ihre IP-Adresse 
                    von Google innerhalb von Mitgliedstaaten der Europäischen Union oder in anderen Vertragsstaaten des Abkommens über 
                    den Europäischen Wirtschaftsraum vor der Übermittlung in die USA gekürzt. Nur in Ausnahmefällen wird die volle 
                    IP-Adresse an einen Server von Google in den USA übertragen und dort gekürzt.
                  </p>

                  <p className="font-medium text-foreground mt-4">Zwecke der Verarbeitung</p>
                  <p>
                    Im Auftrag des Betreibers dieser Website wird Google diese Informationen benutzen, um Ihre Nutzung der Website 
                    auszuwerten, um Reports über die Websiteaktivitäten zusammenzustellen und um weitere mit der Websitenutzung und 
                    der Internetnutzung verbundene Dienstleistungen gegenüber dem Websitebetreiber zu erbringen.
                  </p>
                  <p>
                    Die von uns gesendeten und mit Cookies verknüpften Daten werden nach 14 Monaten automatisch gelöscht. Die Löschung 
                    von Daten, deren Aufbewahrungsdauer erreicht ist, erfolgt automatisch einmal im Monat.
                  </p>

                  <p className="font-medium text-foreground mt-4">Rechtsgrundlage</p>
                  <p>
                    Die Nutzung von Google Analytics erfolgt auf Grundlage Ihrer Einwilligung gemäß Art. 6 Abs. 1 lit. a DSGVO und 
                    § 25 Abs. 1 TTDSG. Die Einwilligung ist jederzeit widerrufbar. Die Datenübertragung in die USA wird auf die 
                    Standardvertragsklauseln der EU-Kommission gestützt.
                  </p>

                  <p className="font-medium text-foreground mt-4">Google Consent Mode</p>
                  <p>
                    Wir verwenden den Google Consent Mode v2. Dieser stellt sicher, dass Google Analytics erst nach Ihrer 
                    Einwilligung aktiv wird. Wenn Sie die Verwendung von Analyse-Cookies ablehnen, werden keine Tracking-Daten 
                    an Google übermittelt.
                  </p>

                  <p className="font-medium text-foreground mt-4">Browser Plugin</p>
                  <p>
                    Sie können die Speicherung der Cookies durch eine entsprechende Einstellung Ihrer Browser-Software verhindern. 
                    Sie können darüber hinaus die Erfassung der durch das Cookie erzeugten und auf Ihre Nutzung der Website bezogenen 
                    Daten (inkl. Ihrer IP-Adresse) an Google sowie die Verarbeitung dieser Daten durch Google verhindern, indem Sie 
                    das unter folgendem Link verfügbare Browser-Plugin herunterladen und installieren:{" "}
                    <a 
                      href="https://tools.google.com/dlpage/gaoptout?hl=de" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="text-primary hover:underline"
                    >
                      https://tools.google.com/dlpage/gaoptout
                    </a>.
                  </p>

                  <p className="font-medium text-foreground mt-4">Weitere Informationen</p>
                  <p>
                    Mehr Informationen zum Umgang mit Nutzerdaten bei Google Analytics finden Sie in der Datenschutzerklärung von Google:{" "}
                    <a 
                      href="https://support.google.com/analytics/answer/6004245?hl=de" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="text-primary hover:underline"
                    >
                      https://support.google.com/analytics/answer/6004245
                    </a>.
                  </p>
                </div>

                <h3 className="text-xl font-semibold mb-3 mt-6">Analyse-Tool DiekerIT</h3>
                <div className="text-muted-foreground space-y-3">
                  <p>
                    Zusätzlich zu Google Analytics verwenden wir ein eigenes Analyse-Tool (DiekerIT Analytics), das auf unserem 
                    eigenen Server gehostet wird. Dieses Tool erfasst anonymisierte Nutzungsdaten, um die Nutzererfahrung zu 
                    verbessern und technische Probleme zu erkennen.
                  </p>
                  <p>
                    Die Datenerfassung erfolgt vollständig anonymisiert und es werden keine personenbezogenen Daten gespeichert. 
                    Die Verarbeitung erfolgt auf Grundlage unseres berechtigten Interesses an der Analyse und Optimierung unserer 
                    Website (Art. 6 Abs. 1 lit. f DSGVO).
                  </p>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4">5. Datenerfassung auf dieser Website</h2>
                
                <h3 className="text-xl font-semibold mb-3 mt-6">Registrierung und Nutzerkonto</h3>
                <div className="text-muted-foreground space-y-3">
                  <p>
                    Sie können sich auf unserer Website registrieren, um zusätzliche Funktionen auf der Seite zu nutzen. 
                    Die dazu eingegebenen Daten verwenden wir nur zum Zwecke der Nutzung des jeweiligen Angebotes oder 
                    Dienstes, für den Sie sich registriert haben. Die bei der Registrierung abgefragten Pflichtangaben 
                    müssen vollständig angegeben werden.
                  </p>
                  <p>
                    Die Verarbeitung der bei der Registrierung eingegebenen Daten erfolgt auf Grundlage Ihrer Einwilligung 
                    (Art. 6 Abs. 1 lit. a DSGVO). Sie können eine von Ihnen erteilte Einwilligung jederzeit widerrufen.
                  </p>
                </div>

                <h3 className="text-xl font-semibold mb-3 mt-6">Medizinische Notfalldaten</h3>
                <div className="text-muted-foreground space-y-3">
                  <p className="font-medium text-foreground">Besonderer Schutz sensibler Gesundheitsdaten</p>
                  <p>
                    MediQR verarbeitet besondere Kategorien personenbezogener Daten nach Art. 9 DSGVO, insbesondere 
                    Gesundheitsdaten. Diese umfassen Informationen über Medikamente, Allergien, Vorerkrankungen, Blutgruppe 
                    und andere medizinische Informationen.
                  </p>
                  <p>
                    Die Verarbeitung dieser sensiblen Daten erfolgt ausschließlich:
                  </p>
                  <ul className="list-disc list-inside space-y-2 ml-4">
                    <li>mit Ihrer ausdrücklichen Einwilligung (Art. 9 Abs. 2 lit. a DSGVO)</li>
                    <li>zum Schutz lebenswichtiger Interessen (Art. 9 Abs. 2 lit. c DSGVO)</li>
                    <li>zur Gesundheitsvorsorge (Art. 9 Abs. 2 lit. h DSGVO)</li>
                  </ul>
                  <p className="mt-3">
                    Ihre medizinischen Daten werden verschlüsselt gespeichert und sind nur über den von Ihnen generierten 
                    QR-Code zugänglich. Wir geben Ihre Gesundheitsdaten niemals an Dritte weiter, außer dies ist für die 
                    Notfallversorgung erforderlich (Rettungskräfte, Ärzte).
                  </p>
                </div>

                <h3 className="text-xl font-semibold mb-3 mt-6">QR-Code Generierung</h3>
                <div className="text-muted-foreground space-y-3">
                  <p>
                    Die von Ihnen eingegebenen Daten werden verwendet, um einen personalisierten QR-Code zu erstellen. 
                    Dieser QR-Code enthält einen Link zu Ihrem verschlüsselten Notfallprofil. Die Verarbeitung erfolgt 
                    auf Grundlage Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO).
                  </p>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4">6. Newsletter und E-Mail-Versand</h2>
                
                <h3 className="text-xl font-semibold mb-3 mt-6">Newsletterdaten</h3>
                <div className="text-muted-foreground space-y-3">
                  <p>
                    Wenn Sie den auf der Website angebotenen Newsletter beziehen möchten, benötigen wir von Ihnen eine 
                    E-Mail-Adresse sowie Informationen, welche uns die Überprüfung gestatten, dass Sie der Inhaber der 
                    angegebenen E-Mail-Adresse sind und mit dem Empfang des Newsletters einverstanden sind. Weitere Daten 
                    werden nicht bzw. nur auf freiwilliger Basis erhoben.
                  </p>
                  <p>
                    Diese Daten verwenden wir ausschließlich für den Versand der angeforderten Informationen und geben diese 
                    nicht an Dritte weiter. Die Verarbeitung der in das Newsletter-Anmeldeformular eingegebenen Daten erfolgt 
                    ausschließlich auf Grundlage Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO). Die erteilte Einwilligung 
                    zur Speicherung der Daten, der E-Mail-Adresse sowie deren Nutzung zum Versand des Newsletters können Sie 
                    jederzeit widerrufen.
                  </p>
                </div>

                <h3 className="text-xl font-semibold mb-3 mt-6">Einsatz eines Massenmail-Dienstleisters</h3>
                <div className="text-muted-foreground space-y-3">
                  <p>
                    Wir nutzen zur Abwicklung des Newsletter-Versands und zur Versendung von transaktionalen E-Mails 
                    (z.B. Registrierungsbestätigungen, Rechnungen, Abo-Hinweise) einen externen Dienstleister.
                  </p>
                  <p>
                    <strong className="text-foreground">Zweck:</strong> Versand von E-Mails<br />
                    <strong className="text-foreground">Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. a DSGVO (Einwilligung) 
                    für Marketing-E-Mails, Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung) für transaktionale E-Mails.
                  </p>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4">7. Plugins und Tools</h2>
                
                <h3 className="text-xl font-semibold mb-3 mt-6">Google Fonts</h3>
                <div className="text-muted-foreground space-y-3">
                  <p>
                    Diese Seite nutzt zur einheitlichen Darstellung von Schriftarten so genannte Google Fonts, die von Google 
                    bereitgestellt werden. Beim Aufruf einer Seite lädt Ihr Browser die benötigten Fonts in ihren Browsercache, 
                    um Texte und Schriftarten korrekt anzuzeigen.
                  </p>
                  <p>
                    Zu diesem Zweck muss der von Ihnen verwendete Browser Verbindung zu den Servern von Google aufnehmen. 
                    Hierdurch erlangt Google Kenntnis darüber, dass über Ihre IP-Adresse diese Website aufgerufen wurde. 
                    Die Nutzung von Google Fonts erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Der Websitebetreiber 
                    hat ein berechtigtes Interesse an der einheitlichen Darstellung des Schriftbildes auf seiner Website.
                  </p>
                  <p>
                    Weitere Informationen zu Google Fonts finden Sie unter{" "}
                    <a 
                      href="https://developers.google.com/fonts/faq" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="text-primary hover:underline"
                    >
                      https://developers.google.com/fonts/faq
                    </a>
                    {" "}und in der Datenschutzerklärung von Google:{" "}
                    <a 
                      href="https://policies.google.com/privacy" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="text-primary hover:underline"
                    >
                      https://policies.google.com/privacy
                    </a>.
                  </p>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4">8. eCommerce und Zahlungsanbieter</h2>
                
                <h3 className="text-xl font-semibold mb-3 mt-6">Kunden- und Vertragsdaten</h3>
                <div className="text-muted-foreground space-y-3">
                  <p>
                    Wir erheben, verarbeiten und nutzen personenbezogene Kunden- und Vertragsdaten zur Begründung, 
                    inhaltlichen Ausgestaltung und Änderung unserer Vertragsbeziehungen. Personenbezogene Daten über die 
                    Inanspruchnahme dieser Website (Nutzungsdaten) erheben, verarbeiten und nutzen wir nur, soweit dies 
                    erforderlich ist, um dem Nutzer die Inanspruchnahme des Dienstes zu ermöglichen oder abzurechnen.
                  </p>
                  <p>
                    Rechtsgrundlage hierfür ist Art. 6 Abs. 1 lit. b DSGVO.
                  </p>
                </div>

                <h3 className="text-xl font-semibold mb-3 mt-6">Datenübermittlung bei Vertragsschluss</h3>
                <div className="text-muted-foreground space-y-3">
                  <p>
                    Wir übermitteln personenbezogene Daten an Dritte nur dann, wenn dies im Rahmen der Vertragsabwicklung 
                    notwendig ist, etwa an das mit der Zahlungsabwicklung beauftragte Kreditinstitut.
                  </p>
                  <p>
                    Eine weitergehende Übermittlung der Daten erfolgt nicht bzw. nur dann, wenn Sie der Übermittlung 
                    ausdrücklich zugestimmt haben. Eine Weitergabe Ihrer Daten an Dritte ohne ausdrückliche Einwilligung, 
                    etwa zu Zwecken der Werbung, erfolgt nicht.
                  </p>
                  <p>
                    Grundlage für die Datenverarbeitung ist Art. 6 Abs. 1 lit. b DSGVO, der die Verarbeitung von Daten zur 
                    Erfüllung eines Vertrags oder vorvertraglicher Maßnahmen gestattet.
                  </p>
                </div>

                <h3 className="text-xl font-semibold mb-3 mt-6">Zahlungsdienste (Stripe)</h3>
                <div className="text-muted-foreground space-y-3">
                  <p>
                    Folgende Zahlungsdienste / Zahlungsdienstleister setzen wir im Rahmen dieser Website ein:
                  </p>
                  
                  <p className="font-medium text-foreground mt-4">Stripe</p>
                  <p>
                    Anbieter dieses Zahlungsdienstes ist Stripe Payments Europe, Limited (SPEL), 1 Grand Canal Street Lower, 
                    Grand Canal Dock, Dublin, D02 H210, Irland (im Folgenden „Stripe" genannt). Mit Hilfe von Stripe können 
                    wir verschiedene Zahlungsarten auf unserer Website integrieren. Einzelheiten finden Sie in den 
                    Datenschutzbestimmungen von Stripe:{" "}
                    <a 
                      href="https://stripe.com/de/privacy" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="text-primary hover:underline"
                    >
                      https://stripe.com/de/privacy
                    </a>.
                  </p>
                  <p>
                    Zur Zahlungsabwicklung werden Ihre eingegebenen Zahlungsdaten (z.B. Name, E-Mail-Adresse, Kontonummer, 
                    Kreditkartendaten) direkt an Stripe übermittelt und von Stripe verarbeitet. Wir erhalten von Stripe 
                    lediglich eine Bestätigung, ob die Zahlung erfolgreich war oder fehlgeschlagen ist.
                  </p>
                  <p>
                    Die Übermittlung Ihrer Daten an Stripe erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO 
                    (Vertragsabwicklung) und unseres berechtigten Interesses an einem reibungslosen und sicheren 
                    Zahlungsvorgang (Art. 6 Abs. 1 lit. f DSGVO). Die Übermittlung in die USA stützt sich auf die 
                    Standardvertragsklauseln der EU-Kommission.
                  </p>
                  <p>
                    Details zur Datenverarbeitung durch Stripe finden Sie in der Datenschutzerklärung von Stripe:{" "}
                    <a 
                      href="https://stripe.com/de/privacy" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="text-primary hover:underline"
                    >
                      https://stripe.com/de/privacy
                    </a>.
                  </p>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4">9. Datensicherheit</h2>
                <div className="text-muted-foreground space-y-3">
                  <p>
                    Wir verwenden innerhalb des Website-Besuchs das verbreitete SSL-Verfahren (Secure Socket Layer) in 
                    Verbindung mit der jeweils höchsten Verschlüsselungsstufe, die von Ihrem Browser unterstützt wird. 
                    In der Regel handelt es sich dabei um eine 256-Bit-Verschlüsselung.
                  </p>
                  <p>
                    Wir weisen darauf hin, dass die Datenübertragung im Internet (z.B. bei der Kommunikation per E-Mail) 
                    Sicherheitslücken aufweisen kann. Ein lückenloser Schutz der Daten vor dem Zugriff durch Dritte ist 
                    nicht möglich.
                  </p>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4">10. Ihre Rechte als betroffene Person</h2>
                <div className="text-muted-foreground space-y-3">
                  <p>Bei Fragen zur Erhebung, Verarbeitung oder Nutzung Ihrer personenbezogenen Daten können Sie sich jederzeit an uns wenden. Sie haben folgende Rechte:</p>
                  <ul className="list-disc list-inside space-y-2 ml-4">
                    <li>Recht auf Auskunft über Ihre bei uns gespeicherten Daten</li>
                    <li>Recht auf Berichtigung unrichtiger Daten</li>
                    <li>Recht auf Löschung Ihrer Daten</li>
                    <li>Recht auf Einschränkung der Verarbeitung</li>
                    <li>Recht auf Datenübertragbarkeit</li>
                    <li>Widerspruchsrecht gegen die Verarbeitung</li>
                    <li>Beschwerderecht bei einer Aufsichtsbehörde</li>
                  </ul>
                </div>
              </section>

              <section className="mt-8 p-6 bg-primary/5 rounded-lg border border-primary/20">
                <p className="text-sm text-muted-foreground">
                  <strong className="text-foreground">Hinweis:</strong> Diese Datenschutzerklärung wurde mit größter Sorgfalt erstellt. 
                  Dennoch können wir nicht ausschließen, dass einzelne Angaben veraltet oder unvollständig sind. 
                  Bitte kontaktieren Sie uns bei Fragen zu Ihren Daten.
                </p>
                <p className="text-sm text-muted-foreground mt-2">
                  Stand: {new Date().toLocaleDateString('de-DE', { year: 'numeric', month: 'long' })}
                </p>
              </section>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="py-12 px-4 bg-background border-t border-border">
        <div className="container mx-auto max-w-6xl">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 rounded-lg bg-gradient-primary flex items-center justify-center">
                <Heart className="w-5 h-5 text-white" />
              </div>
              <span className="font-semibold text-lg gradient-text">MediQR</span>
            </div>
            <div className="flex gap-4 text-sm">
              <Link to="/impressum" className="text-primary hover:underline">
                Impressum
              </Link>
              <Link to="/datenschutz" className="text-primary hover:underline">
                Datenschutz
              </Link>
              <Link to="/agb" className="text-primary hover:underline">
                AGB
              </Link>
              <Link to="/widerrufsrecht" className="text-primary hover:underline">
                Widerrufsrecht
              </Link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Datenschutz;
